/**
 * Phase 32 Batch A — DapNow password policy (mirror of backend validate_password_strength).
 *
 * Required:
 *   - ≥ 8 chars
 *   - ≥ 1 letter
 *   - ≥ 1 digit
 *   - ≥ 1 non-alphanumeric symbol
 */

export const PASSWORD_POLICY_ERROR =
  "La password deve contenere almeno 8 caratteri, una lettera, un numero e un simbolo.";

export function validatePasswordPolicy(pw) {
  if (typeof pw !== "string" || pw.length < 8) return PASSWORD_POLICY_ERROR;
  const hasLetter = /\p{L}/u.test(pw);
  const hasDigit = /\d/.test(pw);
  // any character that is not a letter, not a digit, not whitespace
  const hasSymbol = /[^\p{L}\d\s]/u.test(pw);
  if (!(hasLetter && hasDigit && hasSymbol)) return PASSWORD_POLICY_ERROR;
  return null;
}

/** Returns { valid: bool, checks: { length, letter, digit, symbol } } for UI hints. */
export function passwordChecks(pw) {
  const length = typeof pw === "string" && pw.length >= 8;
  const letter = /\p{L}/u.test(pw || "");
  const digit = /\d/.test(pw || "");
  const symbol = /[^\p{L}\d\s]/u.test(pw || "");
  return { valid: length && letter && digit && symbol, length, letter, digit, symbol };
}
